import React from "react";
import { Box, Chip, Divider, Pagination, Typography } from "@mui/material";
import { CardsWrapper } from "./styles";
import { formatDate } from "../../../../utils/formatDate";
import TableRowMenu from "../../../../Components/MaterialTable/TableRowMenu";
import {
	AffiliateUser,
	COUPON_STATUS_COLOR,
	COUPON_STATUS_LABEL,
	CouponStatusEnum
} from "../../../../store/services/affiliate/dto/affiliate.dto";

const AffiliateUsersCardsList = ({
	data,
	setConfirmActivateStatusUser,
	page,
	perPage,
	totalItems,
	onPageChange
}: {
	data: AffiliateUser[];
	setConfirmActivateStatusUser: ({
		id,
		coupon,
		status
	}: {
		id: string;
		coupon: string;
		status: CouponStatusEnum;
	}) => void;
	page?: number;
	perPage?: number;
	totalItems?: number;
	onPageChange?: (page: number) => void;
}) => {
	return (
		<CardsWrapper>
			{(data || []).map(item => {
				return (
					<Box key={item.userId} className={"card"}>
						<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
							<Typography fontWeight={"bold"}>
								{item.firstName} {item.lastName}
							</Typography>
							<Chip label={item.coupon} size={"small"} variant={"outlined"} />
						</Box>
						<Divider />
						<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
							<Box display={"flex"} flexDirection={"column"}>
								<Typography fontWeight={"bold"}>Email</Typography>
								<Typography>{item.email}</Typography>
							</Box>
							<Divider />
							<Box display={"flex"} flexDirection={"column"}>
								<Typography fontWeight={"bold"}>Business Name</Typography>
								<Typography>{item.businessName}</Typography>
							</Box>
							<Divider />
							<Box>
								<Chip
									label={COUPON_STATUS_LABEL[item.status]}
									color={COUPON_STATUS_COLOR[item.status]}
									size={"small"}
								/>
							</Box>
							<Divider />
							<Box className={"card-footer"} pb={1}>
								<Typography variant={"caption"} color={"textSecondary"}>
									{formatDate(item.createdAt, "Africa/Cairo", "PP")}
								</Typography>
								<TableRowMenu
									items={[
										{
											label: "Activate",
											visible: item.status === CouponStatusEnum.pending || item.status === CouponStatusEnum.disabled,
											onSelected: () =>
												setConfirmActivateStatusUser({
													id: item.userId,
													coupon: item.coupon,
													status: CouponStatusEnum.active
												})
										},
										{
											label: "Disable",
											visible: item.status === CouponStatusEnum.active,
											onSelected: () =>
												setConfirmActivateStatusUser({
													id: item.userId,
													coupon: item.coupon,
													status: CouponStatusEnum.disabled
												})
										}
									]}
								/>
							</Box>
						</Box>
					</Box>
				);
			})}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange && onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default AffiliateUsersCardsList;
